<template>



  <div class="container-fluid">
    <div class="row mb-3">
      <div class="col-sm-12 col-md-3">
        <stats-card
            :title="`Dönem`"
            :sub-title="formoptions.find(i=>i.value==month).text"
            icon="fas fa-chart-bar text-white"
            class="mb-4 mb-xl-0 bg-gradient-info">
        </stats-card>
      </div>
      <div class="col-sm-12 col-md-3">
        <stats-card
            :title="`Toplam ${areas.tip}`"
            :sub-title="totalPrice+' TL'"
            icon="fas fa-chart-bar text-white"
            class="mb-4 mb-xl-0 bg-gradient-warning">
        </stats-card>
      </div>
    </div>
    <div class="card">
      <div class="card-header d-flex justify-content-between items-center">
        <div>
          <h2>
            {{areas.title}}
          </h2>
        </div>

        <div class="d-flex">
          <button class="btn btn-primary mr-2 btn-sm" @click="getReport">Rapor Al</button>
          <b-form-group>
            <b-form-select :options="formoptions" title="Rapor Dönemi" @change="currentPage=1; $refs.table.refresh(); " v-model="month"></b-form-select>
          </b-form-group>
        </div>
      </div>
      <div class="card-body">
        <VueHtml2pdf
            :show-layout="true"
            :float-layout="false"
            :enable-download="true"
            :preview-modal="false"
            :paginate-elements-by-height="1400"
            :filename="`${formoptions.find(i=>i.value==month).text}`"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            :margin="[20,20,20,20]"
            pdf-orientation="landscape"
            pdf-content-width="100%"
            ref="html2Pdf"
        >
          <section slot="pdf-content" style="width: 100% !important;">

            <b-table ref="table" :items="getData" :fields="fields" responsive :tbody-tr-class="rowClass">


              <template v-slot:cell(id)="data">

                {{data.index+1}}.
                <b>{{areas.tip}} </b> ({{rentSale[data.item.process.type || '']}})

              </template>
              <template v-slot:cell(price)="data">
                {{data.item.price}} TL
              </template>
              <template v-slot:cell(last_payment_date)="data">
<!--                <div :style="moment().format('Y-MM-DD') > moment(data.item.last_payment_date).format('Y-MM-DD') ? 'color:red; font-weight:bolder' : ''">-->
                  {{moment(data.item.last_payment_date).format('D/M/Y dddd')}}

<!--                </div>-->
              </template>
              <!--          <template v-slot:cell(date)="data">-->
              <!--            <span v-if="data.item.date!=null">-->
              <!--              {{moment(data.item.date).format('DD/M/Y dddd')}}-->
              <!--            </span>-->
              <!--          </template>-->
              <template v-slot:cell(actions)="data">
                <b-button v-if="true" :variant="areas.buttonColor" size="sm" @click="changeAccountingType(data.item.id)">{{areas.buttonText}}</b-button>
                <router-link v-else :to="{ name:'show-client' , params:{id:data.item.client_id}}" class="badge badge-secondary text-darker" tag="a">Taksit Ödemesini Müşteri Sayfasından Yapınız</router-link>
              </template>
              <template v-slot:cell(created_at)="data">
                {{data.item.services.map(services=>services.service.name).join(",")}}
              </template>
            </b-table>
          </section>
        </VueHtml2pdf>

        <Pagination :c-page="currentPage" @changePage="changePage" :last_page="last_page" :refresh-table="refreshTable" />
        <div class="my-2 text-right">
          Toplam Alacak: <b>{{totalPrice}} TL</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "../../request";
import moment from "moment";
import Pagination from "../../components/Pagination";
import VueHtml2pdf from  'vue-html2pdf'

export default {
  components: {Pagination, VueHtml2pdf},
  methods:{
    changePage(e){
      this.currentPage=e
      this.refreshTable()
    },
    rowClass(item, type) {
      if (item && type === 'row') {
        if (moment().format('Y-MM-DD') > moment(item.last_payment_date).format('Y-MM-DD')) {
          return 'bg-pink text-white'
        } else {
          return ''
        }
      } else {
        return null
      }
    },


    refreshTable(){
      this.$refs.table.refresh()
    },
    getData(){
      return request.get('/future-accountings',this.parameters()).then(res=>{
        this.last_page=res.data.accountings.last_page
        this.totalPrice=res.data.totalPrice
        return res.data.accountings.data
      }).catch(err=>{
        this.error('Hata!');
      })
    },
    parameters(){
      return {
        params:{
          type:this.type,
          month:this.month,
          page:this.currentPage
        }
      }
    },
    getReport(){

      this.$refs.html2Pdf.generatePdf()
    },
    changeAccountingType(id) {
      request.put('change-accounting-type',{
        id,
        type:this.areas.changeType,
        date:moment().format(("Y-M-D"))
      }).then(res=>{
        this.$refs.table.refresh()
        this.success(this.areas.successMessage)
      }).catch(err=>{
        this.error("Hata var!")
      })
    }
  },
  computed:{
    areas(){
      const area={
        "credit":{
          title:"Alacaklar",
          tip:"Alacak",
          buttonText:"Alındı(Gelire Dönüştür)",
          buttonColor:"success",
          changeType:"income",
          successMessage:"Alacak Başarıyla Gelire Dönüştürüldü!"
        },
        "debt":{
          title:"Ödemeler",
          tip:"Ödeme",
          buttonText:"Ödendi(Gidere Dönüştür)",
          buttonColor:"warning",
          changeType:"expense",
          successMessage:"Ödeme başarıyla gidere dönüştürüldü!"
        }
      }
      return area[this.type]
    },
    fields(){
      return [
        { key: 'id', label: 'Tip' },

        { key: 'title', label: 'Açıklama' },
        { key: 'client.full_name', label: 'Müşteri Ad Soyad' },
        { key: 'price', label: 'Tutar' },
        { key: 'last_payment_date', label: 'Son Ödeme Tarihi' },
        { key: 'created_at', label: 'Ürünler' },
        { key: 'actions', label: '' },
      ]
    },
  },
  data(){
    return{
      rentSale:{
        rent:"Kiralama",
        sale:"Satış"
      },
      totalPrice:0,
      last_page:1,
      type:"credit",
      formoptions:[],
      accountings:[],
      moment,
      month: moment().month()+1,
      currentPage: 1,
      perPage: 15,
    }
  },
  mounted() {
    this.type=this.$route.params.id
    moment.locale("tr")
    this.formoptions=[...this.formoptions,...moment.months().map((e,i)=>({value:i+1,text:e+"-"+moment().year()}))]
    this.getData()
  },
  watch:{
    $route(){
      // location.reload()
      this.type=this.$route.params.id
      this.getData()
      this.$refs.table.refresh()
    }
  }
}
</script>

<style scoped>

</style>